import React from 'react';
import strings from "../../../localization";
import { getError, hasError } from "../../../functions/Validation";
import { Button, TextField } from "@material-ui/core";

const FamousCitizenForm = ({
    onSubmit,
    onCancel,
    onChange,
    errors,
    data,
    isDisabled
}) => {
    return (

        <form id='user-form'>
            <TextField
                label={strings.famousCitizen.form.code + "*"}
                error={hasError(errors, 'code')}
                helperText={getError(errors, 'code')}
                fullWidth
                autoFocus
                name='code'
                onChange={onChange}
                margin="normal"
                defaultValue={data.code}
                value={data.code}
                InputLabelProps={{
                    shrink: true,
                }}
                disabled = {isDisabled}
            />
            <TextField
                label={strings.famousCitizen.form.description + "*"}
                error={hasError(errors, 'description')}
                helperText={getError(errors, 'description')}
                fullWidth
                name='description'
                onChange={onChange}
                margin="normal"
                defaultValue={data.description}
                value={data.description}
                InputLabelProps={{
                    shrink: true,
                }}
                disabled = {isDisabled}
            />
            
            {
                !isDisabled &&
                <div className='submit-container'>
                    <Button variant="contained" color="primary" onClick={onSubmit}>
                        {strings.famousCitizen.form.ok}
                    </Button>
                    <Button variant="contained" color="secondary" onClick={onCancel}>
                        {strings.famousCitizen.form.cancel}
                    </Button>
                </div>
            }
        </form>
    )};

export default FamousCitizenForm;